import { NavLink } from 'react-router-dom'
import { LayoutDashboard, BriefcaseBusiness, CalendarRange } from 'lucide-react'
import { useLang } from '../../contexts/LangContext'

const baseClass = 'inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors'

export default function AdminNav() {
  const { t } = useLang()

  const items = [
    { to: '/admin', label: t('Επισκόπηση', 'Overview'), icon: <LayoutDashboard className="h-4 w-4" />, end: true },
    { to: '/admin/providers', label: t('Πάροχοι', 'Providers'), icon: <BriefcaseBusiness className="h-4 w-4" /> },
    { to: '/admin/bookings', label: t('Κρατήσεις', 'Bookings'), icon: <CalendarRange className="h-4 w-4" /> },
  ]

  return (
    <nav className="mt-8 flex flex-wrap gap-3">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => [
            baseClass,
            isActive
              ? 'border-primary-500 bg-primary-50 text-primary-700'
              : 'border-slate-200 bg-white text-slate-600 hover:border-primary-200 hover:text-primary-700',
          ].join(' ')}
        >
          {item.icon}
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}
